import script from "./NotificationsDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsDropdown.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsDropdown.vue?vue&type=style&index=0&id=809b77f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-809b77f4"]])

export default __exports__